import { Chip } from "@octopus-energy/coral/atoms"
import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { useFormatAgreementStatus } from "../../hooks/useFormatAgreementStatus"
import { useGetAgreementStatusColor } from "../../hooks/useGetAgreementStatusColor"

const graphQLFragment = {
    agreement: graphql(
        `
            fragment AgreementStatus_Agreement on AgreementType {
                ...useGetAgreementStatusColor_Agreement
                ...useFormatAgreementStatus_Agreement
            }
        `,
        [
            useGetAgreementStatusColor.fragments.agreement,
            useFormatAgreementStatus.fragments.agreement,
        ]
    ),
}

interface AgreementStatusProps {
    accountNumber: string
    agreement: FragmentOf<typeof graphQLFragment.agreement>
}

export function AgreementStatus(props: AgreementStatusProps) {
    const agreement = readFragment(graphQLFragment.agreement, props.agreement)
    const { accountNumber } = props
    const formatAgreementStatus = useFormatAgreementStatus({
        accountNumber,
    })
    const getAgreementStatusColor = useGetAgreementStatusColor({
        accountNumber,
    })

    return (
        <Chip
            size="small"
            color={getAgreementStatusColor({ agreement })}
        >
            {formatAgreementStatus({ agreement })}
        </Chip>
    )
}

AgreementStatus.messages = [...useFormatAgreementStatus.messages] as const

AgreementStatus.fragments = graphQLFragment

AgreementStatus.queryOptions = {
    ...useFormatAgreementStatus.queryOptions,
}
